// extracted by mini-css-extract-plugin
export default {"title":"user-details-page_title__fm694","disclaimer":"user-details-page_disclaimer__1SU7s","contactConsent":"user-details-page_contactConsent__6soib"};